import { RouteProps } from 'react-router';
import ResetPassword from './ResetPassword';
import SetPassword from './SetPassword';
import SignUpOtp from './SignUpOtp';
import SignUpPage from './SignUpPage';
import VerifyPassword from './VerifyOtp';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import ForgotPasswordOtp from './ForgotPasswordOtp';
import SignInQuestionnaire from './SignInQuestionnaire';
import ResetQuestionOtp from './ResetQuestionOtp';
import SignUpQuestionnaire from './SignUpQuestionnaire';
import ResetQuestionnaire from './ResetQuestionnaire';

export const PublicRoutes: RouteProps[] = [
    {
        path: `/signin`,
        component: Login,
    },
    {
        path: `/signup`,
        component: SignUpPage,
    },
    {
        path: `/set-password`,
        component: SetPassword,
    },
    {
        path: `/verify-password`,
        component: VerifyPassword,
    },
    {
        path: `/reset-password`,
        component: ResetPassword,
    },
    {
        path: `/signup-otp`,
        component: SignUpOtp,
    },
    {
        path: `/forgot-password`,
        component: ForgotPassword,
    },
    {
        path: `/forgot-password-otp`,
        component: ForgotPasswordOtp,
    },
    {
        path: `/forgot-password-questionnaire`,
        component: SignInQuestionnaire,
    },
    {
        path: `/signin-questionnaire`,
        component: SignInQuestionnaire,
    },
    {
        path: '/reset-question-otp',
        component: ResetQuestionOtp,
    },
];
